import React from "react";
import PublishProductionButton from "../PublishProductionButton";
import { usePermissions } from "../../Auth/PermissionsContext";
import { promoteTokenForType } from "../../Pages/Publication/publicationUtils";

export type PublishAfterSaveButtonProps = {
	/** Identifiant stable du contenu qui vient d'être enregistré. */
	contentId: string;
	/** Type de contenu (clé), pour le jeton de mise en production propre au type. */
	contentType?: string | null;
	/** Appelé quand la publication a réussi : l'appelant ferme la modale, rafraîchit l'état. */
	onPublished?: () => void;
};

/**
 * Le bouton « Mettre en production » de la modale qui suit un enregistrement.
 *
 * Il n'apparaît QUE si la personne détient un droit de mise en production : le droit global de
 * déploiement, ou le droit de promotion propre au type du contenu (le serveur applique le même
 * OU dans son gate). Sans droit, rien n'est rendu : la modale reste celle d'un rédacteur, qui
 * enregistre et laisse la publication à quelqu'un d'autre. Le bouton réutilise le bouton de
 * publication unitaire, donc la même confirmation, le même appel et les mêmes messages d'erreur.
 */
export const resolvePublishToken = (
	can: (token: string) => boolean,
	contentType?: string | null
): string | null => {
	if (can("feature:deployment:write")) return "feature:deployment:write";
	const typed = promoteTokenForType(contentType);
	return typed !== "feature:deployment:write" && can(typed) ? typed : null;
};

const PublishAfterSaveButton: React.FC<PublishAfterSaveButtonProps> = ({ contentId, contentType, onPublished }) => {
	const { can } = usePermissions();
	const token = resolvePublishToken(can, contentType);
	if (!token || !contentId) return null;
	return (
		<PublishProductionButton
			contentId={contentId}
			token={token}
			label="Mettre en production"
			onPublished={onPublished}
			className="inline-flex items-center gap-2 rounded-full bg-[#005CA9] px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-[#004b8a] disabled:cursor-not-allowed disabled:bg-slate-300"
		/>
	);
};

export default PublishAfterSaveButton;
